import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.visibility.who.just.me': {
    id: 'profile.visibility.who.just.me',
    defaultMessage: 'Just me',
    description: 'What users can see this area?',
  },
  'profile.visibility.who.everyone': {
    id: 'profile.visibility.who.everyone',
    defaultMessage: 'Everyone on {siteName}',
    description: 'What users can see this area?',
  },
});

export default messages;
